import genericUtil from '../../util/genericUtil'
import _ from 'lodash'

class SocketRestClient {
  constructor(opts) {
    this.domain = opts.domain
    this.socketRestDispatcher = opts.socketRestDispatcher
    this.currentRequests = {}
    this.currentRequestsContents = {}
    this.currentRequestTimers = {}
    this.currentId = 0
    this.socketRestDispatcher.domains[this.domain].onValue(this.handleData.bind(this))
  }

  nextRequestId() {
    this.currentId += 1
    return this.domain + ":" + this.currentId
  }

  request(request) {
    const requestId = this.nextRequestId()
    let deferred
    this.currentRequests[requestId] = deferred = genericUtil.defer()
    this.currentRequestTimers[requestId] = Date.now()
    request.requestId = requestId
    this.currentRequestsContents[requestId] = request
    this.socketRestDispatcher.send(request)
    deferred.promise.abort = () => {
      deferred.reject({
        code: 0,
        result: {error: {type: "abort"}}
      })
      delete this.currentRequests[requestId]
      delete this.currentRequestsContents[requestId]
      this.socketRestDispatcher.send({
        abort: true,
        requestId: requestId
      })
    }
    return deferred.promise
  }

  handleData(data) {
    if (data.handleReconnect) {
      this._handleReconnect()
      return
    }
    const deferred = this.currentRequests[data.requestId]
    if (!deferred) { return }
    delete this.currentRequests[data.requestId]
    delete this.currentRequestsContents[data.requestId]
    const startTime = this.currentRequestTimers[data.requestId]
    delete this.currentRequestTimers[data.requestId]
    data = _.assign(data, {
      requestDuration: Date.now() - startTime
    })
    // while 1xx and 3xx codes aren't necessarily errors, this client isn't set up to properly handle them
    if (data.code >= 200 && data.code < 300) {
      deferred.resolve(data)
    } else {
      deferred.reject(data)
    }
  }

  _handleReconnect() {
    for (const requestId in this.currentRequests) {
      if (this.currentRequests.hasOwnProperty(requestId)) {
        const request = this.currentRequestsContents[requestId]
        if (request) {
          console.log('SocketRestClient reconnected. Reissuing request for: ', requestId)
          // Just re-send the request across the new channel.
          // The request will still contain the same ID, so the existing
          // deferred will properly handle the new response
          this.socketRestDispatcher.send(request)
        }
      }
    }
  }
}

export default {
  create(options) {
    const client = new SocketRestClient(options)
    return client.request.bind(client)
  }
}
